import { Card, Col } from 'antd'
import React, { useEffect } from 'react'
import usecustomStyles from '../../Common/customStyles';
import { ArrowUpRight, Briefcase, CircleDollarSign, UserCircle2 } from 'lucide-react';
import CountUp from 'react-countup';
import {styled} from 'styled-components';
import { Spin } from 'antd/lib';


const customStyles = usecustomStyles();

const TextMuted = styled.div`
      color: ${({ theme }) => theme.token.textMute};
`;

const BgInfo = styled.div`
      background-color: ${({ theme }) => theme.token.colorInfoBg};
`;

const BgSuccess = styled.div`
      background-color: ${({ theme }) => theme.token.colorSuccessBg};
`;
const BgWarning = styled.div`
      background-color: ${({ theme }) => theme.token.colorWarningBg};
`;


const Widget = ({data}) => {

    return (
        <React.Fragment >
            <>
            
            {data ?  data.map((el , index)=>{
                return(
                    <Col key={index} lg={12} xl={8} sm={12} xs={24} className="custom_widget">                           {/* counter blocks */}
                <Card style={{ marginBottom: 0 }}>
                    <div style={{ display: "flex", justifyContent: "space-between" , alignItems: 'center'}}>
                        <div>
                            <p style={{ textTransform: "capitalize" , marginBottom: '.7em'}} className='md'>{el.title}</p>
                            {/* <h3 className="text_xl" style={{ marginBottom: '10px' }}>{el.prefix?`${el.prefix}`: null}<CountUp start={0} end={el.count} duration={3} /> */}
                            <h3 className="text_xl" style={{ marginBottom: '0px' }}>
                                {el.currency && `${el.currency}`}
                                {Math.floor(el.count)}
                            </h3>
                            {
                                el.increase && 
                                ( 
                                    <div style={{ display: "flex", alignItems: "center" }}>
                                <h5 className="sm" style={{fontWeight: 500, color: customStyles.colorSuccess, alignItems: "center", marginBottom: '0' }}>
                                    +30%&nbsp;
                                </h5>
                                <TextMuted className='sm' style={{ marginBottom: '0', marginLeft: '4px'  }} > than last month</TextMuted>
                            </div>
                                )
                            }
                            
                        </div>
                       <figure style={{width: "calc(45px + .3vw)"}}>
                            <img src={el?.icon} className="img_full contain" />
                       </figure>
                    </div>
                </Card>
            </Col>
                )
            }): 
            <div className="spinner center">
                        <Spin />
                    </div>
            }
            </>
           
            
        </React.Fragment >
    )
}

export default Widget